var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeDocuments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 4C2 2.89543 2.89543 2 4 2H16C17.1046 2 18 2.89543 18 4V19C18 19.5523 18.4477 20 19 20C19.5523 20 20 19.5523 20 19V9C20 8.44771 20.4477 8 21 8C21.5523 8 22 8.44772 22 9V19C22 20.6569 20.6569 22 19 22H4C2.89543 22 2 21.1046 2 20V4ZM6 7.46736V12.414C6 12.7376 6.27552 13 6.61538 13H8.46154V10.949C8.46154 10.1399 9.15033 9.48394 10 9.48394C10.8497 9.48394 11.5385 10.1399 11.5385 10.949V13H13.3846C13.7245 13 14 12.7376 14 12.414V7.46736C14 7.26386 13.8891 7.07493 13.7071 6.96828L10.645 5.17386C10.2495 4.94205 9.75054 4.94205 9.35496 5.17386L6.29286 6.96828C6.11086 7.07493 6 7.26386 6 7.46736ZM5.25 16C5.25 16.4142 5.58579 16.75 6 16.75H14C14.4142 16.75 14.75 16.4142 14.75 16C14.75 15.5858 14.4142 15.25 14 15.25H6C5.58579 15.25 5.25 15.5858 5.25 16ZM8 18.25C7.58579 18.25 7.25 18.5858 7.25 19C7.25 19.4142 7.58579 19.75 8 19.75H12C12.4142 19.75 12.75 19.4142 12.75 19C12.75 18.5858 12.4142 18.25 12 18.25H8Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeDocuments);
export default __webpack_public_path__ + "static/media/home-documents.71a40941ace55008b5b8bcdf2b1a9990.svg";
export { ForwardRef as ReactComponent };